import React from 'react';
import PropTypes from 'prop-types';
import ImageWithSkeleton from '../ImageWithSkeleton/ImageWithSkeleton';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('DoubleImage');

const DoubleImage = (props) => {
    const {
        secondarySrc,
        className,
        primarySrcset,
        secondarySrcset,
        hideSecondaryOnMobile,
        ImageComponent = ImageWithSkeleton,
        primaryPlpSrcset,
        secondaryPlpSrcset,
        doubleImageWithoutPadding,
        doubleImageModifier,
    } = props;
    if (!secondarySrc) return <ImageComponent {...props} imageSrcset={primarySrcset} plpSrcset={primaryPlpSrcset} noscript />;

    return (
        <div className={bem(null, null, className)}>
            <div className={bem(null, null, ['primaryImage', doubleImageWithoutPadding, doubleImageModifier])}>
                <ImageComponent {...props} imageSrcset={primarySrcset} plpSrcset={primaryPlpSrcset} noscript />
            </div>
            <div className={bem(null, null, ['secondaryImage', doubleImageWithoutPadding, doubleImageModifier])}>
                <ImageComponent
                    {...props}
                    src={secondarySrc}
                    imageSrcset={secondarySrcset}
                    plpSrcset={secondaryPlpSrcset}
                    hideOnMobile={hideSecondaryOnMobile}
                    noscript
                />
            </div>
        </div>
    );
};

DoubleImage.propTypes = {
    loading: PropTypes.bool,
    secondarySrc: PropTypes.string,
    secondaryMediaQuery: PropTypes.string,
    aspectRatio: PropTypes.string,
    src: PropTypes.string,
    intersected: PropTypes.bool,
    className: PropTypes.string,
    primarySrcset: PropTypes.string,
    secondarySrcset: PropTypes.string,
    hideSecondaryOnMobile: PropTypes.bool,
    imageSrcsetSize: PropTypes.string,
    ImageComponent: PropTypes.elementType,
    doubleImageWithoutPadding: PropTypes.string,
    doubleImageModifier: PropTypes.string,
};

export default DoubleImage;
